// Generated by ReScript, PLEASE EDIT WITH CARE


var internalError = /* DefaultError */{
  _0: {
    title: /* InternalServerError */3,
    message: "Something went wrong!"
  }
};

var authError = /* DefaultError */{
  _0: {
    title: /* Unauthorized */1,
    message: "Authentication Error"
  }
};

export {
  internalError ,
  authError ,
  
}
/* No side effect */
